import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { AssetService } from '../../services/asset.service';
import { Asset } from '../../models/asset.model';
import { Storage } from "@ionic/storage";
import { ProjectService } from '../../services/project.service';
import { Project } from '../../models/project.model';
import { AlertService } from '../../services/alert.service';
import { LoginPage } from '../login/login';
import { HomeService } from '../home/home.service';
import { SecurityConfiguration } from '../../security/security.configuration';
import { trigger, style, transition, animate, keyframes, query, stagger, group, state, animateChild } from "@angular/animations";
import { TranslateService, } from "@ngx-translate/core";
import { HomePage } from '../home/home';


@IonicPage()
@Component({
  selector: 'page-asset-landing',
  templateUrl: 'asset-landing.html',
  animations: [
    trigger('ngIfAnimation', [
      transition('void => *', [
        query('*', stagger('0ms', [
          animate('0.1s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateX(-75%)', offset: 0 }),
            style({ opacity: .5, transform: 'translateX(5px)', offset: 0.3 }),
            style({ opacity: 1, transform: 'translateX(0)', offset: 1.0 }),
          ]))]), { optional: true }),
      ]),
      transition('* => void', [
        query('*', stagger('0ms', [
          animate('0.1s ease-in', keyframes([
            style({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
            style({ opacity: .5, transform: 'translateX(5px)', offset: 0.3 }),
            style({ opacity: 0, transform: 'translateX(-75%)', offset: 1.0 }),
          ]))]), { optional: true }),
      ])
    ])
  ]
})
export class AssetLandingPage {
  public isSlideMenuOpened: boolean = false;
  public activeComponent: string = "alerts";
  public asset: Asset;
  public cfaUser: boolean;
  public project: Project;
  public username: string;
  public menuType: string = "default";
  public access_token:string;
  public branchDetails: any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private assetService: AssetService,
    private projectService: ProjectService,
    private alertService: AlertService,
    private storage: Storage,
    private homeService: HomeService,
    private platform: Platform,
    private securityConfig: SecurityConfiguration
  ) {
    this.project = this.projectService.get();
    this.asset = this.assetService.get();
    
    if (this.platform.is("mobileweb") || this.platform.is("core")) {
      this.username = JSON.parse(sessionStorage.getItem('id_token_claims_obj')).globalid;
      this.access_token = sessionStorage.getItem('access_token');
      this.username = this.username.replace("~AAD:","");
      let cfaUserStr = JSON.parse(sessionStorage.getItem('cfaUser'));
      cfaUserStr == true ? this.cfaUser = true : this.cfaUser = false;
    }
    else{
      this.storage.get('cfaUser').then((cfaUser) => {
        this.cfaUser = cfaUser;
      }); 
    }
    this.assetService.assetChangedEventEmitter.subscribe((asset) => this.asset = asset);
    this.alertService.showOnboardDiagnostics.subscribe(response => this.activeComponent = 'trends');
    this.getBranchDetails();
  }

  display(type) {
    this.menuType="default";
    this.activeComponent = type;
    sessionStorage.setItem('trendsTimeDuration','12');
  }

  previous(){
    this.navCtrl.setRoot(HomePage);
  }

  toggleMenu() {
    this.isSlideMenuOpened = !this.isSlideMenuOpened;
  }

  selectMenu($event) {
    this.menuType = $event;
    this.isSlideMenuOpened = false;
  }

  logout() {
    if (this.platform.is("mobileweb") || this.platform.is("core")) {
      this.securityConfig.logout();
    }
    else {
      this.storage.clear().then((clear) => {
        this.homeService.resetCustomerList();
        this.navCtrl.setRoot(LoginPage);
      })
    }
  }

   downloadHelpDocument() {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", "assets/imgs/helpdoc.pdf");
    xhr.responseType = "blob";
    xhr.onload = function () {
      let file = new Blob([xhr.response], {
        type: 'application/pdf'
      });
      let url = URL.createObjectURL(file);
      let a = document.createElement('a');
      a.href = url, a.download = "CEP_Mobile_User_Guid.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    };

    xhr.send(null);
  }

  getBranchDetails() {
    this.homeService.getBranchDetails(this.access_token, this.username).subscribe(res => {
      this.branchDetails=res;
    }, (error) => {
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset-landing/asset-landing.ts